module.exports = __webpack_public_path__ + "static/media/twitter.7da0f9d4.svg";